export enum ExpertiseLevel {
    Novice,
    AdvancedBeginner,
    Competent,
    Proficient,
    Expert
}